import useGameProvider from '~/client/components/Game/GameView/GameViewMobile/shared/hooks/useGameProvider';
import useTranslation from '~/client/hooks/i18n/useTranslation';
import GameCarousel from '~/client/shared/game/GameCarousel';
import CarouselPlaceholder from '~/client/shared/LazyLoad/Placeholder/CaroulselPlaceholder';

type Props = {
  titleFont?: string;
};

const MoreByProvider: LazyFC<Props> = ({ titleFont }) => {
  const { providerHandle, providerName, href, width, height } =
    useGameProvider();
  const title = useTranslation('casino.more_by', {
    values: { provider: providerName },
  });
  return (
    <GameCarousel
      big
      title={title}
      href={href}
      menuItem={providerHandle}
      placeholder={
        <CarouselPlaceholder width={width} height={height} href={href} />
      }
      sourcePage="game_page"
      sliderName="more_by_provider"
      titleFont={titleFont}
      testId="more-by-provider"
    />
  );
};

export default MoreByProvider;
//GameCarousel to tw
